import React, { Component } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import axios from "axios";
import { configuration } from "../appConfig";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default class DuplicateVinModal extends Component {
 
  submitDuplicateVin = async () => {
    let err = []
    const vin = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    const url = configuration.duplicateVin;
    const {selectedPartnerId,openDuplicateVinModal} = this.props;
    if (selectedPartnerId == "") {
      Toast.fire({
        type: "error",
        title: this.props.lang("pleaseSelectPartnerId"),
      });
      return;
    }
    const payload = {
      child_partner_id: selectedPartnerId.value || "",
      parent_partner_id: partnerId,
      vin: vin,
    };
    
    try {
      const res = await axios.post(url, payload);
      if (res.data.status == 200 && res.data.success == true) {
        Toast.fire({
          type: "success",
          title: res.data.message,
        });
        this.props.getData(localStorage.getItem("selectedFile"))
        openDuplicateVinModal(true)
      } else if (res.data.status == 200 && res.data.is_child_authorized) {
        Toast.fire({
          type: "error",
          title: res.data.message,
        });
      } else {
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      }
    } catch (error) {
      Toast.fire({
        type: "error",
        title: "Something went wrong!",
      });
    }
  };
  render() {
    const {
      duplicateVinModal,
      openDuplicateVinModal,
      selectedPartnerIdList,
      handleSelectedPartnerId,
      selectedPartnerId,
      lang,
    } = this.props;
    return (
      <Modal
        isOpen={duplicateVinModal}
        className="authorizer_name_modal"
        backdrop="static"
        toggle={() => openDuplicateVinModal()}
      >
        <ModalBody>
          <div className="col-lg-12 col-md-12 col-sm-12 selectmultiplelang defaultlang">
            <div className="mb-3 form-group">
              <label for="defaultlangInput" className="form-label">
                {lang("selectParterId")}
              </label>
              <Select
                className=""
                placeholder=""
                closeMenuOnSelect={true}
                // isMulti
                options={selectedPartnerIdList}
                onChange={handleSelectedPartnerId}
                value={selectedPartnerId}
                defaultValue={selectedPartnerId}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div>
            <Button
              color="secondary"
              className="btn btn-md p-2 mr-2"
              onClick={() => openDuplicateVinModal(true)}
            >
              {" "}
              {lang("Cancel")}{" "}
            </Button>
            <Button
              color="secondary"
              className="btn btn-md p-2 btn-danger"
              onClick={this.submitDuplicateVin}
            >
              {" "}
              {lang("Save")}{" "}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}
